<div id="price-tables" class="page-layout simple fullwidth" > 

    <!-- HEADER -->
    <div class="header" fxLayout="row" fxLayoutAlign="start start">

        <div class="hero-text" fxLayout="column" fxLayoutAlign="center center" fxFlex>

            <div class="h1">{{ 'TOOLBAR.SUBSCRIPCION' | translate}}</div>
            <div class="h3">
                    {{  'TOOLBAR.TEXTO' | translate }}
            </div>

        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
   
    <div class="content" fxLayout="column" *ngIf="cargado">
     
        <!-- PRICE TABLES -->
        <div class="price-tables" fxLayout="row wrap" fxLayoutAlign="center center">
            
            <div class = 'price-table style-1 mat-elevation-z4' fxLayout="column"  *ngFor="let plan of plans">
             
                <div class="package-type primary" *ngIf="plan.stripe === 1">
                    <div *ngIf="(plan.planId === planActual.planId) && (planActual.estado !== 'cancelado')" style="background-color: green;; text-align: center;">{{ 'TOOLBAR.PLANACTUAL' | translate }}</div>
                    <div *ngIf="(plan.planId === planActual.planId) && (planActual.estado === 'cancelado')" style="background-color: red;; text-align: center;">{{ 'TOOLBAR.PLANACTUAL' | translate }}</div>
                    <span>{{ plan.nombre }}</span>
                </div>

                <div class="price" fxLayout="row" fxLayoutAlign="center start" *ngIf="plan.stripe === 1">
                    <div class="currency">€</div>
                    <div fxLayout="row" fxLayoutAlign="center end">
                        <div class="value">{{ plan.precio }}</div>
                        <div class="period">/ {{ 'TOOLBAR.MES' | translate}}</div>
                    </div>
                </div>
                <div *ngIf="plan.stripe === 1" style="text-align: center; font-size: x-small">{{ 'TOOLBAR.IMPUESTO' | translate }}</div>

                <mat-divider *ngIf="plan.stripe === 1"></mat-divider>

                <div class="terms" fxLayout="column" *ngIf="plan.stripe === 1">
                    <div class="term">
                        <span class="text-bold">{{ 'TOOLBAR.LIMITE' | translate }}</span>
                         {{ plan.comentario }}
                    </div>
                    <div class="term" *ngIf="plan.planId ===planActual.planId && (planActual.estado === 'activo') ">
                        <span class="text-bold">{{ 'TOOLBAR.RENOVACION' | translate }}</span>
                          {{ planActual.fechaRenovacion | date: 'dd-MM-yyyy' }}
                    </div>
 
                    <div class="term" *ngIf="plan.planId ===planActual.planId && (planActual.estado === 'cancelado') ">
                        <span class="text-bold">{{ 'TOOLBAR.CANCELADA' | translate }}</span>
                    </div>

                    <div class="term" *ngIf="(plan.planId ===planActual.planId) && (planActual.estado === 'pendiente')">
                        <span class="text-bold">{{ 'TOOLBAR.CANCELARA' | translate }}</span>
                          {{ planActual.fechaRenovacion | date: 'dd-MM-yyyy' }}
                    </div>

                    <div class="term" *ngIf="plan.planId === planActual.planId">
                        <span class="text-bold">{{ 'TOOLBAR.FIRMAS' | translate }}</span>
                        {{ planActual.firmados }}
                    </div>
                </div>

                <button mat-raised-button (click)="subscribirse(plan)" class="cta-button" color="accent" *ngIf="(plan.planId !== cliente.stripe.plan) && (plan.stripe === 1) || (planActual.estado === 'cancelado') && (plan.stripe === 1) ">{{ 'TOOLBAR.BUTTON' | translate }}</button>
                <button mat-raised-button (click)="cancelar_subscripcion(plan)" class="cta-button" color="warn" *ngIf="(plan.planId === cliente.stripe.plan) && (plan.stripe === 1) && (planActual.estado === 'activo') " >{{ 'TOOLBAR.CANCELBUTTON' | translate }}</button>
                
            </div>
        </div>

       
        <!-- / PRICE TABLES -->


    </div>

  

</div>

